<template>
  <main v-if="visible">
    <Loader
      v-if="loader"
      style="margin-left: auto; margin-right: auto; display: block"
    />
    <!-- Pessoais -->
    <transition name="fade">
      <template v-if="formInfoPessoais.showPanel && !loader">
        <div class="panel panel-primary">
          <div
            class="panel-heading"
            @click="formInfoPessoais.showForm = !formInfoPessoais.showForm"
          >
            4.1 - INFORMAÇÕES PESSOAIS
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formInfoPessoais.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade">
            <template v-if="formInfoPessoais.showForm">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-2">
                    <form-helper
                      :inputVar="formInfoPessoais.patrimonio"
                      :form="formInfoPessoais"
                      type="money"
                      validationType="Negative"
                      label="Patrimônio"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-2">
                    <form-helper
                      :inputVar="formInfoPessoais.rendaMensal"
                      :form="formInfoPessoais"
                      type="money"
                      validationType="Negative"
                      label="Renda Mensal"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoPessoais.nome"
                      :form="formInfoPessoais"
                      label="Nome"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-2">
                    <form-helper
                      :inputVar="formInfoPessoais.telefone"
                      :form="formInfoPessoais"
                      label="Telefone Celular"
                      placeholder="(##) #####-####"
                      :mask="'(##) #####-####'"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <form-helper
                      :inputVar="formInfoPessoais.dataNascimento"
                      :form="formInfoPessoais"
                      type="date"
                      label="Data de Nascimento"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoPessoais.tipoDocumento"
                      :form="formInfoPessoais"
                      type="select"
                      :options="formInfoPessoais.optionsTipoDocumento"
                      label="Tipo de Documento"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-2">
                    <form-helper
                      :inputVar="formInfoPessoais.numeroDocumento"
                      :form="formInfoPessoais"
                      label="Nº do Documento"
                      placeholder="Digite"
                      maxlength="11"
                    />
                  </div>
                  <div class="col-md-2">
                    <form-helper
                      :inputVar="formInfoPessoais.dataEmissaoDocumento"
                      :form="formInfoPessoais"
                      type="date"
                      validationType="date"
                      label="Data de Emissão"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoPessoais.orgaoEmissor"
                      :form="formInfoPessoais"
                      type="select"
                      :options="smp_optionsIssuingBodyDocument"
                      label="Orgão Emissor"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-2">
                    <form-helper
                      :inputVar="formInfoPessoais.ufOrgaoEmissor"
                      :form="formInfoPessoais"
                      type="select"
                      :options="formInfoPessoais.optionsEstadoNascimento"
                      placeholder="Selecione"
                      label="UF do Orgão Emissor"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoPessoais.nacionalidade"
                      :form="formInfoPessoais"
                      type="select"
                      :options="formInfoPessoais.optionsNacionalidade"
                      label="Nacionalidade"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-2">
                    <form-helper
                      :inputVar="formInfoPessoais.sexo"
                      :form="formInfoPessoais"
                      label="Sexo"
                      placeholder="Selecione"
                      :disabled="true"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoPessoais.email"
                      :form="formInfoPessoais"
                      validationType="email"
                      label="Email"
                      placeholder="Digite"
                      :disabled="formInfoPessoais.disabledEmail"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoPessoais.nomeMae"
                      :form="formInfoPessoais"
                      validationType="name"
                      label="Nome da Mãe"
                      placeholder="Digite"
                      :disabled="formInfoPessoais.disabledNomeMae"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoPessoais.profissao"
                      :form="formInfoPessoais"
                      type="select"
                      :options="formInfoPessoais.optionsProfissao"
                      label="Profissão"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoPessoais.estadoCivil"
                      :form="formInfoPessoais"
                      type="select"
                      :options="formInfoPessoais.optionsEstadoCivil"
                      label="Estado Civil"
                      placeholder="Selecione"
                    />
                  </div>
                  <div v-if="formInfoPessoais.showConjuge">
                    <div class="col-md-6">
                      <form-helper
                        :inputVar="formInfoPessoais.conjuge"
                        :form="formInfoPessoais"
                        validationType="name"
                        label="Nome do Cônjuge"
                        placeholder="Digite"
                      />
                    </div>
                    <div class="col-md-6">
                      <form-helper
                        :inputVar="formInfoPessoais.documentoConjuge"
                        :form="formInfoPessoais"
                        validationType="cpf"
                        label="Nº do Doc. Cônjuge"
                        placeholder="Digite"
                        maxlength="11"
                        :mask="'###########'"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoPessoais.estadoNascimento"
                      :form="formInfoPessoais"
                      type="select"
                      :options="formInfoPessoais.optionsEstadoNascimento"
                      label="Estado de Nascimento"
                      placeholder="Selecione"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoPessoais.cidadeNascimento"
                      :form="formInfoPessoais"
                      type="select"
                      :options="formInfoPessoais.optionsCidadeNascimento"
                      label="Cidade de Nascimento"
                      placeholder="Selecione"
                      :disabled="formInfoPessoais.disabledCidade"
                    />
                  </div>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
    <!-- Endereco -->
    <transition name="fade">
      <template v-if="formInfoResidencial.showPanel && !loader">
        <div class="panel panel-primary">
          <div
            class="panel-heading"
            @click="
              formInfoResidencial.showForm = !formInfoResidencial.showForm
            "
          >
            4.2 - INFORMAÇÕES RESIDENCIAIS
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formInfoResidencial.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade">
            <template v-if="formInfoResidencial.showForm">
              <div class="panel-body">
                <div class="row">
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formInfoResidencial.cep"
                      :form="formInfoResidencial"
                      label="CEP"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-9">
                    <form-helper
                      :inputVar="formInfoResidencial.endereco"
                      :form="formInfoResidencial"
                      label="Endereço"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formInfoResidencial.numero"
                      :form="formInfoResidencial"
                      label="Número"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-3">
                    <form-helper
                      :inputVar="formInfoResidencial.complemento"
                      :form="formInfoResidencial"
                      label="Complemento"
                      placeholder="Digite"
                    />
                  </div>
                  <div class="col-md-6">
                    <form-helper
                      :inputVar="formInfoResidencial.bairro"
                      :form="formInfoResidencial"
                      label="Bairro"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoResidencial.estado"
                      :form="formInfoResidencial"
                      label="Estado"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoResidencial.cidade"
                      :form="formInfoResidencial"
                      label="Cidade"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
    <!-- Adicionais -->
    <transition name="fade">
      <template v-if="formInfoAdicionais.showPanel && !loader">
        <div class="panel panel-primary">
          <div
            class="panel-heading"
            @click="formInfoAdicionais.showForm = !formInfoAdicionais.showForm"
          >
            4.5 - INFORMAÇÕES ADICIONAIS
            <span class="pull-right">
              <i
                style="font-size: 1.5em"
                :class="
                  formInfoAdicionais.showForm
                    ? 'fa fa-arrow-down'
                    : 'fa fa-arrow-right'
                "
                aria-hidden="true"
              ></i>
            </span>
          </div>
          <transition name="fade">
            <template v-if="formInfoAdicionais.showForm">
              <div class="panel-body">
                <div
                  class="row"
                  :style="[
                    formInfoAdicionais.optionsCertifieldAgent.length == 1
                      ? { display: 'none' }
                      : { display: 'block' },
                  ]"
                >
                  <div class="col-md-12">
                    <form-helper
                      :inputVar="formInfoAdicionais.certifieldAgentId"
                      :form="formInfoAdicionais"
                      type="select"
                      :options="formInfoAdicionais.optionsCertifieldAgent"
                      label="Agente Certificado"
                      placeholder="Selecione"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <form-helper
                      :inputVar="formInfoAdicionais.codigoPedido"
                      :form="formInfoAdicionais"
                      label="Código do Pedido"
                      placeholder="Digite"
                      :disabled="true"
                    />
                  </div>
                  <div class="col-md-8">
                    <form-helper
                      :inputVar="formInfoAdicionais.comentario"
                      :form="formInfoAdicionais"
                      label="Comentário"
                      placeholder="Digite"
                    />
                  </div>
                </div>
                <div class="row">
                  <slot name="buttons"></slot>
                </div>
              </div>
            </template>
          </transition>
        </div>
      </template>
    </transition>
    <div class="col-md-12">
      <Loader v-if="loaderProposta" />
    </div>
  </main>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.panel-body {
  background: #f3f9ff;
}
</style>

<script>
import FormHelper from "../../FormHelper.vue";
import smp_ from "../../santander/SantanderPropostaMixing";
import axios from "axios";

export default {
  name: "SantanderFisico",
  props: {
    visible: { type: Boolean, default: false },
    codigoPedido: { type: String, default: "" },
    cliente: { type: Object, default: null },
    token: { type: String, default: null },
    uuid: { type: String, default: null },
    agencia: { default: null },
    conta: { default: null },
    digito: { default: null },
    parcelaQtde: { default: null },
    parcelaValor: { default: null },
    telefone: { default: null },
    dateOfBirthFoundation: { default: null },
    simulacaoId: { default: null },
    valorEntrada: { default: null },
    valorLiberado: { default: null },
    data1aParcela: { default: null },
  },
  components: {
    FormHelper,
  },
  mixins: [smp_],
  mounted() {},
  watch: {
    visible: function (val) {
      if (val) {
        this.load();
      } else {
        this.unload();
      }
    },

    "formInfoPessoais.estadoNascimento.value": function (val) {
      if (val) this.getCidadesNascimento(val.code);
      else {
        this.formInfoPessoais.cidadeNascimento = new this.$formInput(true);
        this.formInfoPessoais.disabledCidade = true;
      }
    },
    "formInfoPessoais.estadoCivil.value": function (val) {
      if (val.code == 1 || val == "CASADO") {
        this.formInfoPessoais.conjuge = new this.$formInput(true);
        this.formInfoPessoais.documentoConjuge = new this.$formInput(true);

        this.formInfoPessoais.showConjuge = true;
      } else {
        this.formInfoPessoais.conjuge = new this.$formInput(false);
        this.formInfoPessoais.documentoConjuge = new this.$formInput(false);

        this.formInfoPessoais.showConjuge = false;
      }
    },
  },
  computed: {
    formErrorsPessoais: function () {
      const errors = Object.keys(this.formInfoPessoais).filter(
        (key) =>
          this.formInfoPessoais[key].validation &&
          !this.formInfoPessoais[key].validation.status
      );

      return errors.length;
    },
    formErrorsResidenciais: function () {
      const errors = Object.keys(this.formInfoResidencial).filter(
        (key) =>
          this.formInfoResidencial[key].validation &&
          !this.formInfoResidencial[key].validation.status
      );
      return errors.length;
    },
    formErrorsInfoAdicionais: function () {
      const errors = Object.keys(this.formInfoAdicionais).filter(
        (key) =>
          this.formInfoAdicionais[key].validation &&
          !this.formInfoAdicionais[key].validation.status
      );
      return errors.length;
    },
  },
  data() {
    return {
      formInfoPessoais: {
        showForm: true,
        showPanel: true,
        nome: new this.$formInput(true),
        tipoDocumento: new this.$formInput(true),
        optionsTipoDocumento: [],
        numeroDocumento: new this.$formInput(true),
        ufOrgaoEmissor: new this.$formInput(true),
        sexo: new this.$formInput(true),
        patrimonio: new this.$formInput(true),
        rendaMensal: new this.$formInput(true),
        email: new this.$formInput(true),
        telefone: new this.$formInput(true),
        nomeMae: new this.$formInput(true),
        dataEmissaoDocumento: new this.$formInput(true),
        orgaoEmissor: new this.$formInput(true),
        profissao: new this.$formInput(true),
        optionsProfissao: [],
        estadoCivil: new this.$formInput(true),
        optionsEstadoCivil: [],
        estadoNascimento: new this.$formInput(true),
        optionsEstadoNascimento: [],
        cidadeNascimento: new this.$formInput(true),
        optionsCidadeNascimento: [],
        dataNascimento: new this.$formInput(true),
        conjuge: new this.$formInput(false),
        documentoConjuge: new this.$formInput(false),
        nacionalidade: new this.$formInput(true),
        optionsNacionalidade: [],
        disabledCidade: true,
        disabledNomeMae: true,
        showConjuge: false,
        attemptSubmit: false,
        disabledEmail: false,
      },
      formInfoResidencial: {
        showForm: true,
        showPanel: true,
        cep: new this.$formInput(true),
        endereco: new this.$formInput(true),
        numero: new this.$formInput(true),
        complemento: new this.$formInput(false),
        bairro: new this.$formInput(true),
        estado: new this.$formInput(true),
        cidade: new this.$formInput(true),
        idCidade: 0,
        attemptSubmit: false,
      },
      formInfoAdicionais: {
        showForm: true,
        showPanel: true,
        certifieldAgentId: new this.$formInput(true),
        codigoPedido: new this.$formInput(false),
        comentario: new this.$formInput(false),
        optionsCertifieldAgent: [],
        attemptSubmit: false,
      },
      loaderProposta: false,
      loader: false,
      isLoaded: false,
    };
  },
  methods: {
    unload: async function () {
      this.isLoaded = false;
    },
    load: async function () {
      if (!this.isLoaded) {
        this.loader = true;
        this.formInfoAdicionais.codigoPedido.value = this.codigoPedido;
        this.setDadosResidenciais();
        this.formInfoPessoais.telefone.value = this.telefone;
        this.formInfoPessoais.optionsTipoDocumento = await this.getTipoDocumento();
        this.formInfoPessoais.optionsEstadoCivil = await this.getEstadosCivis();
        this.formInfoAdicionais.optionsCertifieldAgent = await this.getCertifiedAgents();
        this.formInfoPessoais.optionsEstadoNascimento = await this.getEstados();
        this.formInfoPessoais.optionsProfissao = await this.getProfissoes();
        this.formInfoPessoais.optionsNacionalidade = await this.getNacionalidades();

        this.setDadosCliente();

        if (this.formInfoAdicionais.optionsCertifieldAgent.length > 0)
          this.formInfoAdicionais.certifieldAgentId.value = this.formInfoAdicionais.optionsCertifieldAgent[0];

        this.loader = false;
        this.isLoaded = true;
      }
    },

    async getCidadesNascimento(uf) {
      let options = await this.GetCidadesPorEstado(uf);
      this.formInfoPessoais.cidadeNascimento = new this.$formInput(true);
      this.formInfoPessoais.optionsCidadeNascimento = options;
      this.formInfoPessoais.disabledCidade = false;
    },

    async sendProposta() {
      const self = this;
      self.loaderProposta = true;
      if (self.formInfoResidencial.idCidade == 0) {
        self.formInfoResidencial.idCidade = await self.getCidadeId(
          this.formInfoResidencial.estado.value,
          self.formInfoResidencial.cidade.value
        );
      }

      self.formInfoPessoais.attemptSubmit = true;
      self.formInfoResidencial.attemptSubmit = true;
      self.formInfoAdicionais.attemptSubmit = true;
      let proposta = this.setDadosProposta();

      if (
        self.formErrorsPessoais === 0 &&
        self.formErrorsResidenciais === 0 &&
        self.formErrorsInfoAdicionais === 0
      ) {
        return await axios
          .post(
            this.$apiUrl + "Santander.svc/proposal",
            {
              proposta: proposta,
              numeroParcelas: self.parcelaQtde,
              valorParcelas: self.parcelaValor,
              token: self.token,
              codigoPedido: self.codigoPedido.split("-")[0] * 1,
              simulacaoId: self.simulacaoId,
              valorEntrada: self.valorEntrada,
              valorLiberado: self.valorLiberado,
              data1aParcela: self.data1aParcela,
            },
            { withCredentials: true }
          )
          .then(async (response) => {
            let r = await self.reCallOnError(
              response.data,
              self,
              self.sendProposta
            );
            if (r) return r;
            self.loaderProposta = false;
            return await self.processaRespostaPropostaFisico(response, self);
          })
          .catch((error) => {
            self.loaderProposta = false;
          });
      } else {
        let totalErrors =
          self.formErrorsPessoais +
          self.formErrorsResidenciais +
          self.formErrorsInfoAdicionais;
        swal({
          title: "Preencha os campos obrigatórios",
          text: "Números de campos a serem preenchidos: " + totalErrors,
          icon: "warning",
        });
        self.loaderProposta = false;
      }
      return null;
    },
    setDadosCliente() {
      this.formInfoPessoais.nome.value = this.cliente.CLI_RAZAOSOCIAL;

      const nacionalidadeFilter = (element) =>
        element.label == this.cliente.CLI_PAIS;
      this.formInfoPessoais.nacionalidade.value = this.formInfoPessoais.optionsNacionalidade.find(
        nacionalidadeFilter
      );

      if (this.cliente.CLI_RG != null && this.cliente.CLI_RG != "") {
        this.formInfoPessoais.numeroDocumento.value = this.cliente.CLI_RG;
        const tipoDocumentoFilter = (element) => element.code == 3;
        this.formInfoPessoais.tipoDocumento.value = this.formInfoPessoais.optionsTipoDocumento.find(
          tipoDocumentoFilter
        );
      }

      if (
        this.cliente.CLI_ORGAOEMISSOR != null &&
        this.cliente.CLI_ORGAOEMISSOR != ""
      ) {
        this.cliente.CLI_ORGAOEMISSOR = this.cliente.CLI_ORGAOEMISSOR.replace(
          /\//g,
          " "
        );
        this.cliente.CLI_ORGAOEMISSOR = this.cliente.CLI_ORGAOEMISSOR.replace(
          /\./g,
          " "
        );
        this.cliente.CLI_ORGAOEMISSOR = this.cliente.CLI_ORGAOEMISSOR.replace(
          /-/g,
          " "
        );
        this.cliente.CLI_ORGAOEMISSOR = this.cliente.CLI_ORGAOEMISSOR.replace(
          /=/g,
          " "
        );
        this.cliente.CLI_ORGAOEMISSOR = this.cliente.CLI_ORGAOEMISSOR.replace(
          /_/g,
          " "
        );
        this.cliente.CLI_ORGAOEMISSOR = this.cliente.CLI_ORGAOEMISSOR.replace(
          /\s+/g,
          " "
        ).trim();

        let orgaoExpedidorArray = this.cliente.CLI_ORGAOEMISSOR.split(" ");
        let orgaoExpedidor = orgaoExpedidorArray[0];
        let orgaoExpedidorUf = orgaoExpedidorArray[1];

        const orgaoExpedidorFilter = (element) =>
          element.code == orgaoExpedidor;
        const orgaoExpedidorUfFilter = (element) =>
          element.code == orgaoExpedidorUf;

        this.formInfoPessoais.ufOrgaoEmissor.value = this.formInfoPessoais.optionsEstadoNascimento.find(
          orgaoExpedidorUfFilter
        );

        this.formInfoPessoais.orgaoEmissor.value = this.smp_optionsIssuingBodyDocument.find(
          orgaoExpedidorFilter
        );
      }

      this.formInfoPessoais.sexo.value =
        this.cliente.CLI_SEXO == "M" ? "Masculino" : "Feminino";
      this.formInfoPessoais.email.value = this.cliente.CLI_EMAIL;
      this.formInfoPessoais.nomeMae.value = this.cliente.CLI_FILIACAOMAE.substring(
        0,
        35
      );

      //this.formInfoPessoais.orgaoEmissor.value = this.cliente.CLI_ORGAOEMISSOR;

      if (this.cliente.CLI_FILIACAOMAE.trim().split(" ").length > 1)
        this.formInfoPessoais.disabledNomeMae = true;
      else this.formInfoPessoais.disabledNomeMae = false;

      this.formInfoPessoais.dataNascimento.value = this.dateOfBirthFoundation;
    },
    setDadosResidenciais() {
      this.formInfoResidencial.cep.value = this.cliente.CLI_CEP;
      this.formInfoResidencial.endereco.value = this.cliente.CLI_ENDERECO;
      this.formInfoResidencial.bairro.value = this.cliente.CLI_BAIRRO;
      this.formInfoResidencial.estado.value = this.cliente.EST_UF;
      this.formInfoResidencial.cidade.value = this.cliente.CLI_CIDADE;
    },
    setDadosProposta() {
      let proposta = {};
      proposta.uuid = this.uuid;

      let customer = {};
      customer.document = this.cliente.CLI_CICCGC;
      customer.email = this.formInfoPessoais.email.value;
      customer.name = this.formInfoPessoais.nome.value;
      customer.participationType = 1;
      customer.dateOfBirthFoundation = this.formInfoPessoais.dataNascimento.value;

      let address = {};
      address.zipCode = this.formInfoResidencial.cep.value;
      address.street = this.formInfoResidencial.endereco.value;
      address.number = this.formInfoResidencial.numero.value;
      address.complement = this.formInfoResidencial.complemento.value;
      address.neighborhood = this.formInfoResidencial.bairro.value;
      address.state = this.formInfoResidencial.estado.value;
      address.city = this.formInfoResidencial.idCidade;
      address.type = "R";

      let natural = {};
      natural.birthCity = this.formInfoPessoais.cidadeNascimento.value.code;
      natural.birthState = this.formInfoPessoais.estadoNascimento.value.code;
      natural.mother = this.formInfoPessoais.nomeMae.value;
      natural.dateOfIssue = this.formInfoPessoais.dataEmissaoDocumento.value;
      natural.monthlyIncome = Math.round(
        this.formInfoPessoais.rendaMensal.value
      );
      natural.patrimony = Math.round(this.formInfoPessoais.patrimonio.value);
      natural.documentId = this.formInfoPessoais.tipoDocumento.value.code;
      natural.documentNumber = this.formInfoPessoais.numeroDocumento.value;
      natural.documentState = this.formInfoPessoais.ufOrgaoEmissor.value.code;
      natural.gender = this.cliente.CLI_SEXO;
      natural.issuingBodyDocument = this.formInfoPessoais.orgaoEmissor.value.code;
      natural.maritalStatus = this.formInfoPessoais.estadoCivil.value.code;
      natural.occupation = this.formInfoPessoais.profissao.value.code;
      natural.nationality = this.formInfoPessoais.nacionalidade.value.code;


      if (this.agencia) {
        let bankReference = {};
        bankReference.agencyCode = this.agencia;
        bankReference.accountCode = this.conta;
        bankReference.accountDigit = this.digito;
        bankReference.bankCode = 33;
        natural.bankReference = bankReference;
      }

      let cellphone = {};
      let telefone = this.formInfoPessoais.telefone.value.replace(
        /[\(\)\.\s-]+/g,
        ""
      );
      cellphone.ddd = telefone.slice(0, 2);
      cellphone.number = telefone.slice(2);
      natural.cellphone = cellphone;

      if (this.formInfoPessoais.showConjuge) {
        let spouse = {};
        spouse.document = this.formInfoPessoais.documentoConjuge.value;
        spouse.name = this.formInfoPessoais.conjuge.value;
        natural.spouse = spouse;
      }

      let additional = {};
      additional.reservationCode = this.formInfoAdicionais.codigoPedido.value;
      additional.comments = this.formInfoAdicionais.comentario.value;
      additional.certifieldAgentId = this.formInfoAdicionais.certifieldAgentId.value.code;

      customer.natural = natural;
      customer.address = address;
      proposta.additional = additional;
      proposta.customer = customer;
      return proposta;
    },
  },
};
</script>